import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const saveServiceRequestByGroup = (state, { payload }) => {
    const SRGroup = {...state.serviceRequestByGroup}

    SRGroup[payload.id]=[...payload.response]
    return {...state, serviceRequestByGroup: SRGroup}
};
const setCurrentGroupServiceRequestIndex = (state, { payload }) => {
  state.indexID=payload
};
      // Modified by: Tarkeshwar Prasad Yadav
      // Modified on: 30/08/2022
      // Jira ticket: JUN-3111
      // Comment: All Tenants: added checkbox to show only active or closed service requests.
 
const setDisplayClosedAndResolvedTickets = (state, { payload }) => {
  state.displayClosedAndResolvedTickets=payload
};
const clearServiceRequestByGroup = (state, { payload })  => {
    let filteredSRByGroup = {...state.serviceRequestByGroup}
    if(payload){
      delete filteredSRByGroup[payload]
    } else {
      filteredSRByGroup = {}
    }
    return {...state,  serviceRequestByGroup: filteredSRByGroup, indexID:null, };
  };
const initialState = {
  serviceRequestByGroup:{},
  indexID:null,
  displayClosedAndResolvedTickets:false
};

export default createReducer(initialState, {
  [TYPES.SAVE_SERVICE_REQUEST_BY_GROUP]: saveServiceRequestByGroup,
  [TYPES.CLEAR_SAVE_SERVICE_REQUEST_BY_GROUP]: clearServiceRequestByGroup,
  [TYPES.SET_CURRENT_GROUP_SERVICE_REQUEST_INDEX]: setCurrentGroupServiceRequestIndex,
  [TYPES.SET_DISPLAY_CLOSE_AND_RESOLVED_TICKETS]:setDisplayClosedAndResolvedTickets
});
